import { CreateOrEditDeploymentTargetTriggerPage } from "./CreateOrEditDeploymentTargetTriggerPage";
export interface CreateDeploymentTargetTriggerPageProps {
    spaceId: string;
    projectSlug: string;
}
export function CreateDeploymentTargetTriggerPage({ spaceId, projectSlug }: CreateDeploymentTargetTriggerPageProps) {
    return <CreateOrEditDeploymentTargetTriggerPage create={true} spaceId={spaceId} projectSlug={projectSlug}/>;
}
